import { getUploadSizeString } from "src/utils";

export const UPLOAD_CONTROL_DEFAULT_PRIMARY_TEXT =
  "Drop or click here to upload new file";
export const UPLOAD_CONTROL_DEFAULT_SECONDARY_TEXT = `maximum file size is ${getUploadSizeString()}`;
